import classNames from 'classnames';
import { BaseRadioGroup } from '../BaseRadioGroup/BaseRadioGroup';
import { RadioGroupProps } from './RadioGroup.types';
import css from './RadioGroup.module.scss';
import { useField } from 'formik';
import FormErrorMessage from '../../Form/FormHelperText/FormErrorMessage/FormErrorMessage';
import RadioFormControl from '../../Form/FormControl/FormControl/FormControl';
import RadioFormLabel from '../../Form/FormLabel/RadioFormLabel/RadioFormLabel';
import { GMFormWrapper } from '../../Form';

/**
 * The `RadioGroup` control creates the structure of the entire `Radio`
 * control with styling while also handling Formik integration.
 *
 * @note Requires Formik context to function.
 *
 * @param name - {@link RadioGroupProps.name name} description.
 * @param inline - {@link RadioGroupProps.inline inline} description.
 * @param label - {@link RadioGroupProps.label label} description.
 * @param ariaLabel - {@link RadioGroupProps.ariaLabel ariaLabel} description.
 * @param children - {@link RadioGroupProps.children children} description.
 */
const RadioGroup = ({
    name,
    inline,
    label,
    ariaLabel,
    children,
}: RadioGroupProps) => {
    const [field, meta] = useField<string>(name);

    return (
        <GMFormWrapper>
            <RadioFormControl error={!!meta.error && meta.touched}>
                {label ? (
                    <RadioFormLabel id={name} label={label} />
                ) : null}
                <BaseRadioGroup
                    classes={{
                        root: classNames(css.radioGroup, inline ? css.inline : null),
                    }}
                    ariaLabel={ariaLabel}
                    name={name}
                    value={field.value}
                    onChange={field.onChange}
                >
                    {children}
                </BaseRadioGroup>
                <FormErrorMessage name={name} />
            </RadioFormControl>
        </GMFormWrapper>
    );
};

export default RadioGroup;
